import { EventBus } from '../event-bus';
import axios from 'axios';
import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { imapDecode } from 'emailjs-utf7';

function rainbowStop(h) {
  let f = (n, k = (n + h * 12) % 12) => 0.5 - 0.5 * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  let rgb2hex = (r, g, b) => '#' + [r, g, b].map(
    x => Math.round(x * 255).toString(16).padStart(2, 0)).join('');
  return rgb2hex(f(0), f(8), f(4));
}

function addMissingParentFolders(folders) {
  const folderNames = Object.keys(folders);
  let addedFolders = {};
  for (const f in folders) {
    let p = folders[f].parent;
    while ((p !== '') && (folderNames.indexOf(p) === -1)) {
      let p2 = '';
      const m = /^(.*)\/[^/]+$/.exec(p);
      if (m) {
        p2 = m[1];
      }
      let newFolder = {
        id: -10,
        msgs: 0,
        new: 0,
        nextuid: 0,
        parent: p2,
        rights: 'l',
        specialUse: [],
        uidvalid: 0,
        unread: 0 };
      console.log('add missing folder', p, newFolder);
      addedFolders[p] = newFolder;
      folderNames.push(p);
      p = p2;
    }
  }
  Object.assign(folders, addedFolders);
}

function getChildFolders(state, folders, parent) {
  const result = Object.keys(folders).reduce((filtered, key) => {
    const f = folders[key];
    if (f.parent === parent) {
      filtered[key] = Object.assign(f, { children: getChildFolders(state, folders, key),
        name: key,
        dispName: ((key) => {
          const i = key.lastIndexOf('/');
          if (i === -1) {
            return imapDecode(key);
          } else {
            return imapDecode(key.substr(i + 1));
          }
        })(key)
      });
      for (let su of f.specialUse) {
        state.specialFolders[su] = key;
      }
    }
    return filtered;
  }, {});
  return result;
}

function makeFolderTree(state, folders) {
  console.log('folders', folders);
  state.specialFolders = {};
  let folderTree = { dispName: 'Root', parent: null, unread: 0, children: getChildFolders(state, folders, '') };
  if (!state.specialFolders['\\Sent']) {
    state.specialFolders['\\Sent'] = 'Sent Items';
  }
  if (!state.specialFolders['\\Trash']) {
    state.specialFolders['\\Trash'] = 'Deleted Items';
  }
  console.log('foldertree', folderTree);
  return folderTree;
}

function updateFolder(folders, newFolderData) {
  // console.log('updatefolder', newFolderData, folders);
  if ((folders.id && folders.id === newFolderData.id)) {
    folders = Object.assign(folders, newFolderData);
    return true;
  }
  for (const x in folders.children) {
    if (updateFolder(folders.children[x], newFolderData)) {
      return true;
    }
  }
  return false;
}

export default {
  startLogin(state) {
    state.loginPending = true;
    state.loginError = '';
  },
  // LocalStorage is expected to be populated for loginSuccess
  loginSuccess(state, username) {
    state.loginPending = false;
    state.isLoggedIn = true;
    state.loginError = '';

    let Authkey = decodeURIComponent(localStorage.getItem('token'));
    console.log('authkey', Authkey);
    axios.defaults.baseURL = localStorage.getItem('server');
    axios.defaults.headers.common['Authorization'] = `VPOP3 ${Authkey}`;
    let wsServer = axios.defaults.baseURL.replace(/^http/, 'ws');
    localStorage.setItem('wsserver', wsServer);
    state.username = localStorage.getItem('username');
    EventBus.$emit('login');
    Sentry.setUser({ username: state.username,
      licence: localStorage.getItem('licenceowner'),
      build: localStorage.getItem('serverbuild') });
    Sentry.addBreadcrumb({
      category: 'ui',
      message: 'Login:' + state.username,
      level: 'info'
    });
  },
  loginFailure(state, err) {
    state.loginPending = false;
    state.loginError = err;
  },
  logout(state, reason) {
    state.isLoggedIn = false;
    state.username = '';
    state.loginError = reason;
    EventBus.$emit('logout');
    Sentry.addBreadcrumb({
      category: 'ui',
      message: 'Logout:' + reason,
      level: 'info'
    });
  },
  clearData(state) {
    state.settings = {
      manualRules: [],
      selectedCalendars: {}
    };
    state.folders = { dispName: 'Root', unread: 0, parent: null, children: {} };
    state.messageEditorMode = 0;
    state.foldersLoaded = false;
    state.settingsLoaded = false;
    state.collectedAddresses = {};
    state.addressBookScopes = [];
    state.addressBookEntries = {};
  },
  setSentry(state, enable) {
    state.sentryEnabled = enable;
  },
  setInternalTrack(state, enable) {
    state.internalTrackEnabled = enable;
  },
  setLogRocket(state, enable) {
    state.logrocketInitialised = enable;
  },
  setSmartLook(state, enable) {
    state.smartlookInitialised = enable;
  },
  setFolders(state, folders) {
    addMissingParentFolders(folders);
    state.folders = makeFolderTree(state, folders);
    EventBus.$emit('foldersLoaded');
    state.foldersLoaded = true;
  },
  setSettings(state, settings) {
    state.settings = settings;
    state.settingsLoaded = true;
    EventBus.$emit('settingsLoaded');
  },
  setCollectedAddresses(state, addresses) {
    state.collectedAddresses = Object.assign(addresses, { _isVue: true }); // _isVue makes the data non-reactive
  },
  setAddressBookScopes(state, scopes) {
    state.addressBookScopes = scopes;
  },
  addAddressBookScope(state, scope) {
    console.log('add addr book scope', scope);
    state.addressBookScopes.push(scope);
    console.log(state.addressBookScopes);
  },
  deleteAddressBookScope(state, dn) {
    const i = state.addressBookScopes.findIndex(s => s.dn === dn);
    if (i !== -1) {
      state.addressBookScopes.splice(i, 1);
    }
  },
  setAddressBookEntries(state, entries) {
    state.addressBookEntries = entries;
  },
  updateAddrBookEntry(state, { dn, entry }) {
    console.log('update addr book entry', dn, entry);
    Vue.set(state.addressBookEntries, dn, entry);
    console.log(state.addressBookEntries);
  },
  deleteAddrBookEntry(state, { dn }) {
    Vue.delete(state.addressBookEntries, dn);
  },
  addAllowedImageSender(state, { id, sender }) {
    state.collectedAddresses[sender] = { id, allowimages: true };
  },
  setEditorMode(state, newMode) {
    state.messageEditorMode = newMode;
  },
  setFolderInfo(state, newInfo) {
    updateFolder(state.folders, newInfo);
  },
  setNewRule(state, newRule) {
    state.newRule = newRule;
  },
  setSetting(state, { name, value }) {
    Vue.set(state.settings, name, value);
  },
  patchSettings(state, { patch }) {
    state.settings = Object.assign({}, state.settings, patch);
  },
  setCalendars(state, { calendars }) {
    let parser = new DOMParser();
    console.log('setCalendars', calendars);
    let colourStop = 0;
    calendars.forEach(c => {
      console.log('process', c);
      if (c.props.hasOwnProperty('http://apple.com/ns/ical/\tcalendar-color')) {
        try {
          const xmlDoc = parser.parseFromString(c.props['http://apple.com/ns/ical/\tcalendar-color'], 'text/xml');
          c.colour = xmlDoc.childNodes[0].textContent;
        } catch (err) {
        }
      } else {
        c.colour = rainbowStop(colourStop);
        colourStop += 1 / calendars.length;
      }
    });
    console.log('setCalendars2', calendars);
    state.calendars = calendars;
  },
  setLanguage(state, { language }) {
    state.language = language;
    localStorage.setItem('webmailLanguage', language);
  },
  setAvailableLanguages(state, { languages }) {
    state.availableLanguages = languages;
  },
  SOCKET_ONOPEN(state, event) {
    console.log('Websocket opened');
    Vue.prototype.$socket = event.currentTarget;
    state.socket.isConnected = true;
  },
  SOCKET_ONCLOSE(state, event) {
    console.log('Websocket closed');
    state.socket.isConnected = false;
  },
  SOCKET_ONMESSAGE(state, message) {
    console.log('Websocket Msg', message);
    state.gotWebSocketData = true;
    console.log('End Receive Socket Message');
    if (message.updates.folders) {
      for (const folder of message.updates.folders) {
        updateFolder(state.folders, folder);
      }
    }
    if (message.updates.currentfolder) {
      console.log('Current folder updates');
      for (const update of message.updates.currentfolder.messages) {
        EventBus.$emit('messageUpdate', { folderId: message.updates.currentfolder.id, update });
      }
    }
    if (message.updates.newmessages) {
      for (const m of message.updates.newmessages) {
        EventBus.$emit('messageDelivery', m);
      }
    }
    if (message.updates.outqueue) {
      if (message.updates.outqueue.messages) {
        for (const m of message.updates.outqueue.messages) {
          EventBus.$emit('outboxMessage', m);
        }
      }
    }
    if (message.updates.settings) {
      for (const s in message.updates.settings) {
        Vue.set(state.settings, s, message.updates.settings[s]);
      }
    }
    if (message.updates.usersettings) {
      for (const s in message.updates.usersettings) {
        Vue.set(state.settings, s, message.updates.usersettings[s]);
      }
    }
  }

};
